import { useEffect, useState } from 'react';
import useLocalStorage from './useLocalStorage';
import useReadLocalStorage from './useReadLocalStorage';
import useShadowRoot from './useShadowRoot';
import { ToolbarPositions } from '@/components/draggableToolbar/DraggableToolbar.types';

export const useDragToolbar = (
  elToolbarRef: React.RefObject<HTMLDivElement>
) => {
  const initPos = useReadLocalStorage(
    'contensis-blocks-preview-toolbar-position'
  );

  const [, setPos] = useLocalStorage(
    'contensis-blocks-preview-toolbar-position',
    initPos
  );

  useEffect(() => {
    if (!initPos) setPos(ToolbarPositions.CenterLeft);
  }, [initPos, setPos]);

  const [toolbar, setToolbar] = useState<HTMLDivElement>();

  useEffect(() => {
    if (elToolbarRef?.current) setToolbar(elToolbarRef.current);
  }, [elToolbarRef]);

  const root = useShadowRoot();

  useEffect(() => {
    const widget = root?.getElementById(
      'contensis-blocks-preview-toolbar-widget'
    );
    const draggable = root?.getElementById('draggable-toolbar');
    const containers = root?.querySelectorAll('.draggable__container');

    const endDrag = (e: Event, container: Element) => {
      if (!toolbar) return;
      e.preventDefault();
      container?.appendChild(toolbar);
      toolbar.style.opacity = '1';
      container?.classList.remove('draggable-point--border');
      draggable?.classList.remove('draggable-points');
      const toolbarPositonFromContainerId = container.getAttribute('id');
      setPos(toolbarPositonFromContainerId);
    };

    if (toolbar && widget) {
      toolbar.addEventListener('dragstart', () => {
        widget.classList?.add('pointer-events--allow');
      });
      toolbar.addEventListener('dragend', () => {
        widget.classList?.remove('pointer-events--allow');
      });
    }
    if (containers && containers.length > 0) {
      containers.forEach(container => {
        container.addEventListener('dragstart', () => {
          if (!toolbar) return;
          toolbar.style.opacity = '0.6';
          draggable?.classList.add('draggable-points');
        });
        container.addEventListener('dragover', e => {
          e.preventDefault();
          container?.classList.add('draggable-point--border');
        });
        container.addEventListener('dragleave', e => {
          e.preventDefault();
          container?.classList.remove('draggable-point--border');
        });
        container.addEventListener('dragend', e => {
          endDrag(e, container);
        });
        container.addEventListener('drop', e => {
          endDrag(e, container);
        });
      });
    }
  }, [toolbar, root, setPos]);
};
